import MedicalHealthInformationForm from './components/Index';
import { MedicalHealthInformationContextProvider } from './Context';

export default function MedicalHealthInformationPage() {
  return (
    <MedicalHealthInformationContextProvider>
      <MedicalHealthInformationForm />
    </MedicalHealthInformationContextProvider>
  );
}
